<template>
    <div class="wrapper" ref="scrollWrapper">
        <img class="content-img" src="../../../assets/img/zfb-activity/bg-9.png" alt="">
        <div class="goListbtn" @click="goAppList"></div>
        <div class="btn-box" v-show="showBtnBox" @click="goAppList">
            <img class="btn-img" src="../../../assets/img/zfb-activity/btn.png" alt=""></img>
        </div>
    </div>
</template>
<script> 
import { callHandler } from '@/util/jsBridge';
export default {
    data() {
        return {
			scrollHandler: null,
            showBtnBox: false,
            isApp: false,
            os: null,
        }
    },
    methods: {
        detectBrowserEnvironment() {
            const ua = navigator.userAgent.toLowerCase();
            
            // 检测操作系统
            const os = {
                isIOS: /iphone|ipad|ipod/.test(ua),
                isAndroid: /android/.test(ua),
                isWindows: /windows/.test(ua),
                isMacOS: /macintosh|mac os x/.test(ua),
                isLinux: /linux/.test(ua),
            };
            
            // 检测浏览器类型
            const browser = {
                isWechat: /micromessenger/.test(ua),
                isSafari: /safari/.test(ua) && !/chrome|crios/.test(ua) && !/android/.test(ua),
                isChrome: /chrome|crios/.test(ua) && !/edg/.test(ua),
                isFirefox: /firefox|fxios/.test(ua),
                isEdge: /edg/.test(ua),
                isSamsung: /samsungbrowser/.test(ua),
            };
            
            // 确定操作系统类型
            let osType = 'unknown';
            if (os.isIOS) osType = 'ios';
            else if (os.isAndroid) osType = 'android';
            else if (os.isWindows) osType = 'windows';
            else if (os.isMacOS) osType = 'macos';
            else if (os.isLinux) osType = 'linux';
            
            // 确定浏览器类型
            let browserType = 'unknown';
            if (browser.isWechat) browserType = 'wechat';
            else if (browser.isSafari) browserType = 'safari';
            else if (browser.isChrome) browserType = 'chrome';
            else if (browser.isFirefox) browserType = 'firefox';
            else if (browser.isEdge) browserType = 'edge';
            else if (browser.isSamsung) browserType = 'samsung';
            
            // 最终结果
            return {
                isWechat: browser.isWechat,
                isAndroid: os.isAndroid && !browser.isWechat,
                isIOS: os.isIOS && !browser.isWechat,
                isMobile: os.isIOS || os.isAndroid,
                isDesktop: !(os.isIOS || os.isAndroid),
                os: osType,
                browser: browserType,
                userAgent: navigator.userAgent // 原始UA，用于调试
            };
        },
        handleScroll(e) {
            const goListbtn = document.querySelector('.goListbtn');
            const rect = goListbtn.getBoundingClientRect();
            const wrapperRect = this.$refs.scrollWrapper.getBoundingClientRect();
            
            // 当 goListbtn 完全滚出视口顶部时显示 btn-box
            if (rect.bottom < wrapperRect.top) {
                this.showBtnBox = true;
            } else {
                this.showBtnBox = false;
            }
        },
        goAppList() {
            if (this.isApp) {
                callHandler('jumpToActWithPath', {
                    path: '/special/rent'
                })
            } else if (this.os.isAndroid) {
                // 此时要尝试打开app
                window.location.href = 'xubeinewapp://com.xubei.shop'; // 安卓协议
                // window.location.href = 'zhihu://'
                setTimeout(() => {
                    console.log('document.hidden', document.hidden);
                    
                    if (!document.hidden) {
                        window.location.href = 'http://static.xubei.com/act/download0418/downloadWeb.html'; // 下载地址
                    }
                }, 1500);
            } else if (this.os.isIOS) {
                // 苹果浏览器
                window.location.href = 'http://static.xubei.com/act/download0418/downloadWeb.html'; // 下载地址
            }
            
        }
    },
    mounted() {
        this.isApp = this.$route.query.source ? true : false;
        this.$refs.scrollWrapper.addEventListener('scroll', this.handleScroll);
        this.os = this.detectBrowserEnvironment()
    },
    beforeDestroy() {
        this.$refs.scrollWrapper.removeEventListener('scroll', this.handleScroll);
    },
}
</script>
<style lang="scss" scoped>
.wrapper {
	position: relative;
	width: 100vw;
    height: 100vh;
	max-height: 100%;
    position: relative;
    overflow:auto;
    margin-top: -.9rem;
}

.content-img{
    position: relative;
}

.goListbtn{
    position: absolute;
    height: 1.57rem;
    width: 100%;
    top: 14rem;
    left: 0;
    z-index: 2;
}
.btn-box{
    position: fixed;
    bottom: 0;
    z-index: 2;
    background-color: #fff;
    padding: .19rem 0;
    left: 0;
    padding-bottom: .5rem;
}
.btn-img{
    
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/zfbActivity/index.vue